import React from "react";
import { Card, CardContent, CardHeader, Grid, TextField, Typography } from "@mui/material";

function TransmittalNotesCard({
  notes = "",
  onNotesChange,
  readOnly = false,
  title = "Notes",
  rows = 6,
}) {
  return (
    <Grid item xs={12}>
      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardHeader
          title={
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", textTransform: "uppercase" }}
            >
              {title}
            </Typography>
          }
          sx={{ pb: 0, px: 2, pt: 2 }}
        />
        <CardContent sx={{ px: 2, pb: 2 }}>
          <TextField
            label="Notes"
            value={notes || ""}
            onChange={(e) => onNotesChange?.(e.target.value)}
            fullWidth
            multiline
            rows={rows}
            size="small"
            InputProps={{
              readOnly,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </CardContent>
      </Card>
    </Grid>
  );
}

export default TransmittalNotesCard;